resolverFullplayerQuery